import { FilterState } from '@marketplace-web/catalog/catalog-data'

import { FilterAction, FilterReducerAction } from './actionTypes'

export const filterReducer = (state: FilterState, action: FilterAction): FilterState => {
  switch (action.type) {
    case FilterReducerAction.CHANGE_FILTERS: {
      return {
        ...state,
        ...action.payload.filters,
      }
    }
    case FilterReducerAction.SET_INITIAL_FILTERS: {
      return {
        ...state,
        ...action.payload.filters,
      }
    }
    default:
      return state
  }
}
